import {
  UPDATE_COUNTRY_IS_FETCHING,
  UPDATE_COUNTRY_LIST,
  UPDATE_CATEGORY_IS_FETCHING,
  UPDATE_CATEGORY_LIST,
  UPDATE_PERMISSIONS_IS_FETCHING,
  UPDATE_PERMISSIONS_LIST
} from "../types";

import { COUNTRY_LIST_URL, CATEGORY_LIST_URL, ACL_GET_PERMISSIONS_LIST_URL } from "../../config";
import { showErrorAlert } from "./alerts";

import makeApiRequest from "../../utils/axios/new-axios";

export const updateCountryList = () => {
  return (dispatch, getState) => {
    const country = getState().appdata.country;
    if (!country.isFetching && (!country.list || country.list.length === 0)) {
      dispatch({ type: UPDATE_COUNTRY_IS_FETCHING, isFetching: true });
      makeApiRequest({
        url: COUNTRY_LIST_URL.url,
        method: COUNTRY_LIST_URL.method
      })
        .then(response => {
          dispatch({ type: UPDATE_COUNTRY_LIST, list: response.data });
        })
        .catch(error => {
          dispatch(
            showErrorAlert(
              "Error Fetching Country List : " +
              (!!error.response
                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                : error.message)
            )
          );
        });
    }
  };
};

export const updateCategoryList = () => {
  return (dispatch, getState) => {
    const category = getState().appdata.category;
    if (
      !category.isFetching &&
      (!category.list || category.list.length === 0)
    ) {
      dispatch({ type: UPDATE_CATEGORY_IS_FETCHING, isFetching: true });
      makeApiRequest({
        url: CATEGORY_LIST_URL.url,
        method: CATEGORY_LIST_URL.method
      })
        .then(response => {
          dispatch({ type: UPDATE_CATEGORY_LIST, list: response.data });
        })
        .catch(error => {
          dispatch(
            showErrorAlert(
              "Error Fetching Category List : " +
              (!!error.response
                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                : error.message)
            )
          );
        });
    }
  };
};


export const updatePermissionsList = () => {
  return (dispatch, getState) => {
    const permissions = getState().appdata.permissions;
    if (
      !permissions.isFetching &&
      (!permissions.list || permissions.list.length === 0)
    ) {
      dispatch({ type: UPDATE_PERMISSIONS_IS_FETCHING, isFetching: true });
      makeApiRequest({
        url: ACL_GET_PERMISSIONS_LIST_URL.url,
        method: ACL_GET_PERMISSIONS_LIST_URL.method
      })
        .then(response => {
          dispatch({ type: UPDATE_PERMISSIONS_LIST, list: response.data });
        })
        .catch(error => {
          dispatch(
            showErrorAlert(
              "Error Fetching Permissions List : " +
              (!!error.response
                ? `${error.response.status}! - ${error.response.data.errorMessage}`
                : error.message)
            )
          );
        });
    }
  };
};